import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { quienSomos } from "../services/Imagenes";
import Footer from "../services/Footer";
import { obtenerCarrusel } from "../services/Api";
import { API_BASE_URL } from "../services/Config";

const Inicio = () => {
  const carruselSettings = {
    dots: false, // Desactivados los dots
    infinite: true,
    speed: 650,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    autoplay: true,
    arrows: true
  };

  const [imagenesCarrusel, setImagenesCarrusel] = useState([]);
  const [imagenesCarruselMovil, setImagenesCarruselMovil] = useState([]);

  useEffect(() => {
    const cargarCarrusel = async () => {
      try {
        const carruselObtenido = await obtenerCarrusel('Carrusel1');
        const carruselMovilObtenido = await obtenerCarrusel('Carrusel2');
        setImagenesCarrusel(carruselObtenido.imagenes);
        setImagenesCarruselMovil(carruselMovilObtenido.imagenes);
      } catch (error) {
        console.error("Error al obtener carrusel:", error);
      }
    };
    cargarCarrusel();
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <div className="overflow-hidden">
        {/* Carrusel Desktop */}
        <div className="w-full hidden md:block relative">
          <Slider {...carruselSettings}>
            {imagenesCarrusel.map((imagen, index) => (
              <div key={index} className="relative">
                <img
                  src={`${API_BASE_URL}${imagen.uri_foto}`}
                  alt={`Carrusel ${index + 1}`}
                  className="w-full object-cover"
                  style={{ height: "50vh" }}
                />
                {/* Texto superpuesto */}
                <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
                  <div className="text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Aros de Origami Únicos</h1>
                    <p className="text-xl text-white max-w-2xl mx-auto">Arte en papel que transforma tu estilo</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        
        {/* Carrusel Móvil */}
        <div className="w-full md:hidden relative">
          <Slider {...carruselSettings}>
            {imagenesCarruselMovil.map((imagen, index) => (
              <div key={index} className="relative">
                <img
                  src={`${API_BASE_URL}${imagen.uri_foto}`}
                  alt={`Carrusel Móvil ${index + 1}`}
                  className="w-full object-cover"
                  style={{ height: "50vh" }}
                />
                {/* Texto superpuesto */}
                <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
                  <div className="text-center px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Aros de Origami Únicos</h1>
                    <p className="text-xl text-white max-w-2xl mx-auto">Arte en papel que transforma tu estilo</p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Quick Features Banner - Sin margen superior */}
        <section className="bg-[#f3e9dc] py-6 -mt-2">
          <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
              <div className="text-center">
                <div className="text-2xl font-bold text-[#6d4c3d]">+100</div>
                <div className="text-[#6d4c3d]">Clientes satisfechos</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-[#6d4c3d]">100%</div>
                <div className="text-[#6d4c3d]">Hecho a mano</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-[#6d4c3d]">Eco</div>
                <div className="text-[#6d4c3d]">Materiales sostenibles</div>
              </div>
            </div>
          </div>
        </section>

        {/* Resto de las secciones (se mantienen igual) */}
        {/* About Us Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center gap-12">
              <div className="md:w-1/2">
                <img
                  src={quienSomos}
                  alt="Quiénes Somos"
                  className="rounded-lg shadow-xl w-full max-w-md mx-auto"
                />
              </div>
              <div className="md:w-1/2">
                <h2 className="text-3xl font-bold text-gray-800 mb-6">
                  Nuestra Historia
                </h2>
                <p className="text-gray-600 text-lg mb-4">
                  En K'arallantas, transformamos simples hojas de papel en obras de arte que puedes llevar contigo. Cada aro es una pieza única, creada con paciencia y dedicación utilizando técnicas tradicionales de origami.
                </p>
                <p className="text-gray-600 text-lg mb-6">
                  Nuestra misión es combinar la belleza del arte japonés con diseños contemporáneos, ofreciendo accesorios sostenibles que cuentan una historia.
                </p>
                
              </div>
            </div>
          </div>
        </section>

        {/* Craft Process Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Nuestro Arte en 3 Pasos</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="bg-[#f3e9dc] w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold text-[#6d4c3d]">1</span>
                </div>
                <h3 className="text-xl font-semibold mb-3">Selección de Papel</h3>
                <p className="text-gray-600">Elegimos cuidadosamente papeles de alta calidad y diseños exclusivos para cada creación.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="bg-[#f3e9dc] w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold text-[#6d4c3d]">2</span>
                </div>
                <h3 className="text-xl font-semibold mb-3">Plegado Artesanal</h3>
                <p className="text-gray-600">Cada pliegue es hecho a mano con precisión, siguiendo técnicas tradicionales de origami.</p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md text-center">
                <div className="bg-[#f3e9dc] w-16 h-16 mx-auto rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold text-[#6d4c3d]">3</span>
                </div>
                <h3 className="text-xl font-semibold mb-3">Acabado Perfecto</h3>
                <p className="text-gray-600">Aplicamos tratamientos especiales para garantizar durabilidad sin perder la esencia del papel.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Lo que dicen nuestros clientes</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="bg-gray-50 p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-[#f3e9dc] rounded-full mr-4 flex items-center justify-center text-[#6d4c3d] font-bold">M</div>
                  <div>
                    <h4 className="font-semibold">María González</h4>
                    <div className="flex text-yellow-400">
                      ★ ★ ★ ★ ★
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 italic">"Mis aros de K'arallantas son mi accesorio favorito. Recibo cumplidos cada vez que los uso y me encanta que son únicos y ecológicos."</p>
              </div>
              
              <div className="bg-gray-50 p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-[#f3e9dc] rounded-full mr-4 flex items-center justify-center text-[#6d4c3d] font-bold">C</div>
                  <div>
                    <h4 className="font-semibold">Carlos Mendoza</h4>
                    <div className="flex text-yellow-400">
                      ★ ★ ★ ★ ★
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 italic">"Compré unos aros para regalar y quedaron encantados. La calidad y el detalle son impresionantes. Definitivamente volveré a comprar."</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-6 text-[#6d4c3d]">¿Lista para lucir arte en tus orejas?</h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto text-[#6d4c3d]">Descubre nuestra colección de aros de origami y encuentra ese par perfecto que habla de ti.</p>
            <div className="flex flex-wrap justify-center gap-4">
            <a href="/catalogo" className="inline-block">
  <button className="bg-[#6d4c3d] hover:bg-[#5a3d30] text-white font-medium py-3 px-8 rounded-full transition duration-300">
    Ver colección
  </button>
</a>

<a href="/contacto" className="inline-block ml-4">
  <button className="border-2 border-[#6d4c3d] text-[#6d4d3d] hover:bg-[#6d4c3d] hover:bg-opacity-10 font-medium py-3 px-8 rounded-full transition duration-300">
    Contactarnos
  </button>
</a>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Inicio;